import { FC, ComponentProps } from 'react';
import { Flex, BoxV2 as Box } from 'portal-commons';

interface InfoItemProps {
  title?: string;
  itemWidths?: string[];
  titleSx?: ComponentProps<typeof Flex>['sx'];
}

type Props = InfoItemProps &
  Omit<ComponentProps<typeof Flex>, keyof InfoItemProps>;

const InfoItem: FC<Props> = ({
  title,
  children,
  itemWidths = ['40%', '60%'],
  sx,
  titleSx,
  ...flexProps
}) => {
  return (
    <Flex
      sx={{
        flex: 1,
        fontSize: 'H300',
        fontWeight: 'semiBold',
        color: 't.black70',
        '> label ~ div': {
          width: itemWidths[1],
          wordWrap: 'break-word',
          lineHeight: 'normal',
        },
        ...sx,
      }}
      {...flexProps}
      data-testid="infoItem"
    >
      {!!title && (
        <Box
          as="label"
          sx={{ fontWeight: 'normal', width: itemWidths[0], ...titleSx }}
          htmlFor={title}
        >
          {title}:
        </Box>
      )}
      <div>{children || 'N/A'}</div>
    </Flex>
  );
};

export default InfoItem;
